import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPStatusesInfo } from '../types/types';

interface IPStatusesState {
  ip_statuses: IPStatusesInfo[];
}

const initialState: IPStatusesState = {
  ip_statuses: [],
};

const ipStatusSlice = createSlice({
  name: 'ipStatus',
  initialState,
  reducers: {
    setIPStatusesList: (state, action: PayloadAction<IPStatusesInfo[]>) => {
      state.ip_statuses = action.payload;
    },

    addIPStatus: (state, action: PayloadAction<IPStatusesInfo>) => {
      state.ip_statuses.push(action.payload);
    },

    removeIPStatus: (state, action: PayloadAction<IPStatusesInfo>) => {
      state.ip_statuses = state.ip_statuses.filter(
        (IPStatus) => IPStatus.id !== action.payload.id,
      );
    },

    clearAllIPStatuses: (state) => {
      state.ip_statuses = [];
    },
  },
});

export const {
  setIPStatusesList,
  addIPStatus,
  removeIPStatus,
  clearAllIPStatuses,
} = ipStatusSlice.actions;
export default ipStatusSlice.reducer;
